













































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import {
  updateBabysitterProfile,
  languagesPayload,
} from '@/interfaces/Payload';
import LanguagePicker from '@/components/dashboard/shared/components/LanguagePicker.vue';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {
    LanguagePicker,
  },
})
export default class BabysitterProfile extends Vue {
  @Prop()
  id!: number;

  public user: any = {};
  public babysitter: any = {};
  public address: any = {};
  public experience: number[] = [];

  public selectedLanguages: any = [];

  public dateMenu: boolean = false;
  public menu: boolean = false;
  public languages: any = [];
  public experiences: number[] = [];

  public levels: any[] = [
    {
      id: 2,
      name: 'Advance',
    },
    {
      id: 3,
      name: 'Intermediate',
    },
    {
      id: 4,
      name: 'Basic',
    },
  ];

  public dataLoading: boolean = true;
  public salaryError: string = '';

  public $refs!: {
    picker: any;
    dateMenu: any;
  };

  public setPayload(babysitter: any) {
    this.user = {
      first_name: babysitter.first_name,
      last_name: babysitter.last_name,
    };

    this.babysitter = {
      contact: babysitter.contact,
      date_of_birth: babysitter.date_of_birth,
      bank_account: babysitter.bank_account,
      training_passed: babysitter.training_passed,
      driving_license: babysitter.driving_license,
      active_driver: babysitter.active_driver,
      smoker: babysitter.smoker,
      animator: babysitter.animator,
      additional_info: babysitter.additional_info,
      gender: babysitter.gender,
      available_full_time: babysitter.available_full_time,
      available_part_time: babysitter.available_part_time,
      full_time_hours: babysitter.full_time_hours,
      part_time_hours: babysitter.part_time_hours,
      years_of_experience: babysitter.years_of_experience,
      salary_range_min: babysitter.salary_range_min,
      salary_range_max: babysitter.salary_range_max,
      availability_start_date: babysitter.availability_start_date,
      availability_times: babysitter.availability_times || {
        mornings: false,
        afternoons: false,
        evenings: false,
        sleepovers: false,
        weekends: false,
        traveling: false,
      },
    };

    this.address = {
      address: babysitter.address.address,
      area_name: babysitter.address.area_name,
      // city: babysitter.address.city.name,
      city_id: babysitter.address.city_id,
      // district: babysitter.address.district,
      // postal_code: babysitter.address.postal_code,
    };

    // if ( babysitter.nativeLanguage ) {
    // 	babysitter.languages.push(babysitter.nativeLanguage);
    // }

    if (babysitter.languages.length > 0) {
      babysitter.languages.forEach((lang: any) =>
        this.$set(this.selectedLanguages, lang.id, {
          language_level: lang.level?.id,
        })
      );
    }

    this.experience = babysitter.experience.map((exp: any) => exp.id);
  }

  public getPayload(): updateBabysitterProfile {
    const {
      availability_times,
      ...babysitterWithoutAvailability
    } = this.babysitter;
    return {
      user: this.user,
      babysitter: babysitterWithoutAvailability,
      address: this.address,
      experience: this.experience,
      languages: {
        ...this.selectedLanguages,
      },
      availability_times: {
        mornings: availability_times.mornings,
        afternoons: availability_times.afternoons,
        evenings: availability_times.evenings,
        sleepovers: availability_times.sleepovers,
        weekends: availability_times.weekends,
        traveling: availability_times.traveling,
      },
    };
  }

  public save() {
    let payload: updateBabysitterProfile = this.getPayload();

    axios
      .put(api.path('v1.admin.babysitters.single', { id: this.id }), payload)
      .then((res) => this.$toast.success(res.data.message))
      .catch((error) => {
        this.$toast.error(error.response.data.message || 'An error occurred');
      });
  }

  public async loadLanguages() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.admin.languages'), { params: params })
      .then((res) => (this.languages = res.data.data));
  }

  public async loadExperiences() {
    let params = {
      paginate: 'no',
      order_sort: 'asc',
    };

    await axios
      .get(api.path('v1.admin.experiences'), { params: params })
      .then((res) => (this.experiences = res.data.data));
  }

  public async loadBabysitter() {
    let res = await axios.get(
      api.path('v1.admin.babysitters.edit', { id: this.id })
    );

    this.setPayload(res.data.data);
  }

  @Watch('dateMenu')
  onValueChange(value: any) {
    value && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
  }

  public setDateOfBirth(date: any) {
    this.$refs.dateMenu.save(date);
  }

  public customTextName(item: any): string {
    return `${item.name} - ${item.level.name}`;
  }

  public genders: any[] = [
    {
      id: true,
      name: 'Female',
    },
    { id: false, name: 'Male' },
  ];

  @Action('languages/fetchLanguages') fetchLanguages: any;
  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  public async mounted() {
    await this.fetchCities();
    await this.fetchLanguages();
    await this.loadExperiences();
    await this.loadBabysitter();

    this.dataLoading = false;
  }

  @Watch('babysitter.available_full_time')
  onFullTimeChange(value: boolean) {
    if (!value) {
      this.babysitter.full_time_hours = null;
      this.babysitter.salary_range_min = null;
      this.babysitter.salary_range_max = null;
    }
  }

  @Watch('babysitter.available_part_time')
  onPartTimeChange(value: boolean) {
    if (!value) {
      this.babysitter.part_time_hours = null;
      Object.keys(this.babysitter.availability_times).forEach((key) => {
        this.babysitter.availability_times[key] = false;
      });
    }
  }
}
